import cleanedFilename from '~/util/cleanedFilename';

export default {
  AND_OR_DROPDOWN: `${cleanedFilename(__filename)}-and-or-dropdown`,
  ADD_CONDITION_BUTTON: `${cleanedFilename(__filename)}-add-condition`,
  LIST_CONTAINER: `${cleanedFilename(__filename)}-list-container`,
  EMPTY_LIST_TEXT: `${cleanedFilename(__filename)}-empty-list-text`,
};
